import { Contact } from "./Contact";
import { FileMetadata } from "./File";

export interface Vehicle {
  id?: number;
  year: string | number;
  make: string;
  model: string;
  color: string;
  plate: LicensePlate;
  trim?: string;
  vin: string;
  towerContactInfo?: Contact;
}

export interface LicensePlate {
  number: string;
  state: string;
  exp?: Date | number | null;
  score?: number; // VR only
  boundingPoly?: VRBoundingPoly; // VR only
}

export interface PartialVehicle {
  id?: number;
  year?: string | number;
  make?: string;
  model?: string;
  color?: string;
  plate?: LicensePlate;
  trim?: string;
  vin?: string;
  NCICCode?: string;
  score?: number; // VR only
  generation?: VRGeneration; // VR only
  boundingPoly?: VRBoundingPoly; // VR only
}

export interface MakeModelAutocompleteOption {
  make: string;
  model: string;
}

export const convertPartialVehicleToVehicle = (pv: PartialVehicle): Vehicle => {
  return {
    id: pv.id || 0,
    year: `${pv.year || ""}`,
    make: pv.make || "",
    model: pv.model || "",
    color: pv.color || "",
    plate: pv.plate || { number: "", state: "" },
    trim: pv.trim || "",
    vin: pv.vin || "",
  };
};

export interface VRResponseBody {
  responses?: VRResponse[];
  error?: VRError;
}

export interface VRError {
  code?: number;
  status?: string;
  message?: string;
}

export interface VRResponse {
  licensePlateAnnotations: VRLicensePlateAnnotation[];
  vehicleAnnotations: VRVehicleAnnotation[];
}

export interface VRLicensePlateAnnotation {
  score: number;
  plate: VRValueScore;
  region: VRValueScore;
  boundingPoly: VRBoundingPoly;
}

export interface VRVehicleAnnotation {
  description: string;
  color: VRValueScore;
  model: VRValueScore;
  make: VRValueScore;
  score: number;
  boundingPoly: VRBoundingPoly;
}

export interface vrAccumulator {
  make: VRValueScore[];
  model: VRValueScore[];
  color: VRValueScore[];
  year: VRValueScore[];
  plateNumber: VRValueScore[];
  plateState: VRValueScore[];
  vin: VRValueScore[];
  trim: VRValueScore[];
}

export interface VRBoundingPoly {
  vertices: VRVertex[];
  normalizedVertices: VRVertex[];
}

export interface VRVertex {
  x: number;
  y: number;
}

export interface VRValueScore {
  score: number;
  value: string;
}

export interface VRGeneration {
  start: number;
  end: number;
}

export interface VRRequestBody {
  images: VRImage[];
}

export interface VRImage {
  imageURL?: string;
  imageBase64?: string;
  runCarfax?: boolean;
  file?: FileMetadata;
}

export interface SaveAndScanResponseBody {
  vehicle: PartialVehicle;
  file: FileMetadata;
  errors: string[];
}
